import React from 'react';
import AudienceLandingPage from './AudienceLandingPage';
import { FUND_CONFIG } from '../data/audienceLandingConfig';

const FundLandingPage: React.FC = () => (
  <AudienceLandingPage config={FUND_CONFIG} />
);

export default FundLandingPage;
